import { render } from "./DownloadResourceDialog.vue?vue&type=template&id=757a07e3&scoped=true"
import script from "./DownloadResourceDialog.vue?vue&type=script&lang=js"
export * from "./DownloadResourceDialog.vue?vue&type=script&lang=js"

import "./DownloadResourceDialog.vue?vue&type=style&index=0&id=757a07e3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757a07e3"]])

export default __exports__